import { Footer } from '@/components/elements/footer/footer.component';
import Navbar from '@/components/elements/navbar/navbar.component';
import { Topbar } from '@/components/elements/topbar/topbar.component';
import { cn } from '@/lib/utils';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  topbar?: boolean;
  pageTitle?: React.ReactNode;
  children: React.ReactNode;
  onCancel?: () => void;
  onNext?: () => void;
}

const MainLayout = ({ children, topbar, pageTitle, onCancel: handleCancel, onNext: handleNext }: Props) => {
  return (
    <div className="overflow-hidden">
      <div className="fixed top-0 left-0 right-0 z-10">
        <Navbar />
        {topbar && <Topbar onNext={handleNext} onToProducts={handleCancel} />}
        <div>{pageTitle}</div>
      </div>
      <div className={cn('mx-19 mb-[60px] xs:mx-6 xs:my-4', topbar ? 'mt-[200px]' : 'mt-[100px]')}>{children}</div>
      <Footer />
    </div>
  );
};

export default MainLayout;
